class BocomalEditorialArticle extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-bce-content]');
    this.toc = this.querySelector('[data-bce-toc]');
    this.mobile = this.querySelector('[data-bce-mobile-toc]');
    this.progress = this.querySelector('[data-bce-progress]');
    this.progressLabel = this.querySelector('[data-bce-progress-label]');
    if (!this.content) return;
    this.headings = [...this.content.querySelectorAll('h2')];
    this.buildToc();
    this.updatePageState = this.updatePageState.bind(this);
    addEventListener('scroll', this.updatePageState, {passive: true});
    addEventListener('resize', this.updatePageState, {passive: true});
    this.updatePageState();
  }

  disconnectedCallback() {
    removeEventListener('scroll', this.updatePageState);
    removeEventListener('resize', this.updatePageState);
  }

  buildToc() {
    if (!this.headings.length) return;
    const links = [];
    const options = ['<option value="">Jump to a section</option>'];
    this.headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `section-${index + 1}`;
      links.push(`<a href="#${heading.id}"><span>${String(index + 1).padStart(2, '0')}</span>${heading.textContent}</a>`);
      options.push(`<option value="#${heading.id}">${heading.textContent}</option>`);
    });
    if (this.toc) {
      this.toc.innerHTML = links.join('');
      this.toc.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
          const id = link.getAttribute('href').slice(1);
          const heading = document.getElementById(id);
          if (!heading) return;
          event.preventDefault();
          this.setActiveHeading(id);
          heading.scrollIntoView({behavior: 'smooth', block: 'start'});
          history.replaceState(null, '', `#${id}`);
        });
      });
    }
    if (this.mobile) {
      this.mobile.innerHTML = options.join('');
      this.mobile.addEventListener('change', () => {
        if (!this.mobile.value) return;
        const id = this.mobile.value.slice(1);
        this.setActiveHeading(id);
        document.getElementById(id)?.scrollIntoView({behavior: 'smooth', block: 'start'});
        history.replaceState(null, '', this.mobile.value);
      });
    }
  }

  setActiveHeading(id) {
    this.querySelectorAll('[data-bce-toc] a').forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
      if (link.classList.contains('is-active')) {
        const toc = link.closest('[data-bce-toc]');
        if (toc && toc.scrollHeight > toc.clientHeight) {
          const linkTop = link.offsetTop - toc.offsetTop;
          const linkBottom = linkTop + link.offsetHeight;
          if (linkTop < toc.scrollTop) toc.scrollTop = linkTop;
          else if (linkBottom > toc.scrollTop + toc.clientHeight) toc.scrollTop = linkBottom - toc.clientHeight;
        }
      }
    });
    if (this.mobile && this.mobile.value !== `#${id}`) this.mobile.value = `#${id}`;
  }

  updatePageState() {
    const activationLine = Math.min(190, Math.max(120, innerHeight * 0.22));
    let active = this.headings[0];
    for (const heading of this.headings) {
      if (heading.getBoundingClientRect().top <= activationLine) active = heading;
      else break;
    }
    if (active) this.setActiveHeading(active.id);
    const start = this.getBoundingClientRect().top + scrollY;
    const end = start + this.offsetHeight - innerHeight;
    const percentage = end > start ? Math.max(0, Math.min(100, Math.round(((scrollY - start) / (end - start)) * 100))) : 0;
    if (this.progress) this.progress.style.width = `${percentage}%`;
    if (this.progressLabel) this.progressLabel.textContent = `${percentage}%`;
  }
}

customElements.define('bocomal-editorial-article', BocomalEditorialArticle);
